import { gql } from "@apollo/client";

export const AVATAR_UPLOAD_URL = gql`
  query AvatarUploadUrl($type: UploadType!) {
    me {
      mediaUploadUrl(type: $type, purpose: PROFILE_AVATAR) {
        url
        key
        fields {
          name
          value
        }
      }
    }
  }
`;
